(() => {
  'use strict';
  if (window.sspMethowKitGuide) return;
  window.sspMethowKitGuide = true;
  const requests = new Map();
  const subscriptions = new Map();
  const getData = url => {
    if (!requests.has(url)) requests.set(url, fetch(url).then(response => {
      if (!response.ok) throw new Error('Preview unavailable');
      return response.json();
    }));
    return requests.get(url);
  };
  function variantId(root) {
    const section = root.closest('[data-section-type="product-page"]');
    const picker = section?.querySelector('variant-picker');
    if (picker?.matches(':defined') && Object.prototype.hasOwnProperty.call(picker, 'currentVariant')) return picker.currentVariant ? String(picker.currentVariant.id) : '';
    const input = section?.querySelector('form[action*="/cart/add"] [name="id"]');
    return input?.value || new URL(location.href).searchParams.get('variant') || root.dataset.kitVariant;
  }
  function paint(root) {
    const data = root.sspKitData;
    if (!data) return;
    const kit = data.kits[root.dataset.kitHandle];
    if (!kit) return;
    const id = variantId(root);
    const variant = kit.variants[id];
    const labels = JSON.parse(root.querySelector('[data-kit-labels]').textContent);
    const image = root.querySelector('[data-kit-image]');
    const caption = root.querySelector('[data-kit-disclaimer]');
    if (!variant) {
      image.hidden = true;
      root.querySelector('[data-kit-loading]').hidden = true;
      root.querySelector('[data-kit-frame]').textContent = '';
      caption.textContent = labels.unavailable;
      return;
    }
    if ((kit.kind === 'single' || kit.kind === 'replacement') && root.sspKitVariant !== id) root.sspKitLens = variant.lens;
    root.sspKitVariant = id;
    const buttons = [...root.querySelectorAll('[data-kit-lens]')];
    const key = root.sspKitLens || kit.lenses[0];
    const frame = kit.frames?.[key] || variant.frame;
    const name = buttons.find(button => button.dataset.kitLens === key)?.textContent.trim() || key;
    const imageFrame = frame === 'unknown' ? 'black' : frame;
    const replacement = kit.kind === 'replacement';
    const lensOnly = frame === 'neon';
    const src = replacement ? kit.images?.[key] : lensOnly ? data.lensOnly?.[key] : data.images[imageFrame]?.[key];
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kitLens === key)));
    root.querySelector('[data-kit-name]').textContent = name;
    root.querySelector('[data-kit-loading]').hidden = true;
    const guidance = root.querySelector('[data-kit-guidance]');
    if (guidance) {
      try {
        const detail = JSON.parse(guidance.textContent)[key];
        if (detail) {
          root.querySelector('[data-kit-light]').textContent = detail.use;
          root.querySelector('[data-kit-description]').textContent = detail.description;
          const transmission = root.querySelector('[data-kit-transmission]');
          transmission.hidden = !detail.transmission;
          transmission.querySelector('strong').textContent = detail.transmission || '';
        }
      } catch (_) { /* Static product information remains available. */ }
    }
    if (src) {
      image.src = src;
      image.alt = name + ' · ' + (replacement ? 'Replacement lens only; frame sold separately' : lensOnly ? labels.lens_only : (labels.frames[imageFrame] || imageFrame));
      image.hidden = false;
      root.querySelector('[data-kit-frame]').textContent = replacement || frame === 'unknown' ? '' : labels.frames[frame];
      caption.textContent = replacement ? labels.replacement : lensOnly ? labels.lens_only : frame === 'unknown' ? labels.example : kit.kind === 'instructor' && key === 'clear' ? labels.instructor_clear : labels.preview;
    } else {
      image.hidden = true;
      root.querySelector('[data-kit-frame]').textContent = labels.frames[frame] || variant.label;
      caption.textContent = labels.unavailable;
    }
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-ssp-kit-guide]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      getData(root.dataset.kitSource).then(data => { root.sspKitData = data; paint(root); }).catch(() => {
        root.querySelector('[data-kit-loading]').textContent = JSON.parse(root.querySelector('[data-kit-labels]').textContent).load_error;
      });
      if (window.MinimogEvents?.subscribe) {
        const section = root.closest('[data-section-type="product-page"]');
        const unsubscribe = window.MinimogEvents.subscribe(`${root.dataset.kitProductId}__VARIANT_CHANGE`, (_, picker) => {
          if (!picker || section?.contains(picker)) requestAnimationFrame(() => paint(root));
        });
        subscriptions.set(root, unsubscribe);
      }
      if (window.customElements) customElements.whenDefined('variant-picker').then(() => { if (root.isConnected) requestAnimationFrame(() => paint(root)); });
    });
    subscriptions.forEach((unsubscribe, root) => { if (!root.isConnected) { if (typeof unsubscribe === 'function') unsubscribe(); subscriptions.delete(root); } });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-kit-lens]');
    if (!button) return;
    const root = button.closest('[data-ssp-kit-guide]');
    root.sspKitLens = button.dataset.kitLens;
    paint(root);
  });
  document.addEventListener('keydown', event => {
    const button = event.target.closest('[data-kit-lens]');
    if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const buttons = [...button.parentElement.querySelectorAll('[data-kit-lens]')];
    let index = buttons.indexOf(button);
    index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
    buttons[index].focus();
    buttons[index].click();
  });
  const sync = event => {
    const section = event.target.closest?.('[data-section-type="product-page"]');
    if (section) requestAnimationFrame(() => section.querySelectorAll('[data-ssp-kit-guide]').forEach(paint));
  };
  document.addEventListener('change', sync);
  document.addEventListener('ssp:variant-change', sync);
  window.addEventListener('popstate', () => requestAnimationFrame(() => document.querySelectorAll('[data-ssp-kit-guide]').forEach(paint)));
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-ssp-kit-guide]').forEach(paint));
  document.addEventListener('shopify:section:load', () => init());
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(() => init()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
